import moment, { MomentInput } from 'moment';

import { BaseEntity, TRANSFORMERS_KEY } from './base';
import { addMetadataToMap } from './util';

type BaseEntityType<T> = { new (...args: any[]): T };

/**
 * BaseEntity property decorator to provide custom transformation of values
 * @param  {(value:any)=>any} transformer transform function
 */
export const Transform = (transformer: (value: any) => any) => {
  return <T extends BaseEntity, K extends string>(target: T, key: K) => {
    addMetadataToMap(TRANSFORMERS_KEY, key, transformer, target);
  };
};

// Tranformers

/**
 * Convert json date to native Date
 * @param  {} value any valid MomentInput
 * @returns Date
 */
export const toDate = (value: MomentInput): Date => moment(value).toDate();

/**
 * Tranformer factory to convert value to specified BaseEntity
 * @param  {BaseEntityType<T>} entity
 * @returns (value) => BaseEntity | BaseEntity[]
 */
export function toEntity<T extends BaseEntity>(entity: BaseEntityType<T>) {
  return (value): T | T[] => {
    if (Array.isArray(value)) {
      return value.map((item) => new entity(item));
    } else {
      return typeof value === 'object' && new entity(value);
    }
  };
}



// WEBPACK FOOTER //
// ./src/models/base/transform.ts